module.exports = __webpack_public_path__ + "static/media/20190805_50Days2019_Tag14_0696AT.cb16ef3f.jpg";